import { render, staticRenderFns } from "./TrainRefundDetail.vue?vue&type=template&id=82b79a2a&scoped=true&"
import script from "./TrainRefundDetail.vue?vue&type=script&lang=js&"
export * from "./TrainRefundDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrainRefundDetail.vue?vue&type=style&index=0&id=82b79a2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b79a2a",
  null
  
)

export default component.exports